import "../css/style.scss";

// Our modules / classes
import Video from "../src/modules/video";
import Slider from "../src/modules/ap-slider";
import Humburger from "../src/modules/apHamburgerMenu";
import JqueryValidationForm from  "jquery-validation";
import ContactForm from "../src/modules/apContactFormValidation";

let video = Video;
let logoSlider = Slider;
let hamburger = Humburger;
let jqueryValidationForm = JqueryValidationForm;
let contactFormValidation = ContactForm;